(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("library-website", [], factory);
	else if(typeof exports === 'object')
		exports["library-website"] = factory();
	else
		root["library-website"] = factory();
})(window, function() {
return 